import { render, staticRenderFns } from "./CFooter.vue?vue&type=template&id=5e121858&scoped=true&"
import script from "./CFooter.vue?vue&type=script&lang=js&"
export * from "./CFooter.vue?vue&type=script&lang=js&"
import style0 from "./CFooter.vue?vue&type=style&index=0&id=5e121858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e121858",
  null
  
)

export default component.exports